import axios from 'axios';
export const errCheck = (err) => {
    if (err.response.data.statusCode == '401') {
        localStorage.removeItem('token');
        window.location.href = '/login';
    }
};
export default class ReportService {
    async getReportList(pName, pCategory, sdate, edate,uName) {
        return await axios
            .post(`/receipt/report_registration/all`, {
                product_name: pName,
                product_category: pCategory,
                start_date: sdate,
                end_date: edate,
                username:uName,
            })
            .then((res) => res.data)
            .catch((err) => {
                errCheck(err);
            });
    }
    async viewReport(ids) {
        return await axios
            .post(`/receipt/report_registration/details`, {
                report_id: ids,
            })
            .then((res) => res.data.reportData[0]).catch((err) => {
                errCheck(err);
            });
    }
    async getExcel(pName, pCategory, sdate, edate,uName,dreason) {
        return await axios({
            url: `/receipt/report/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                product_name: pName,
                product_category: pCategory,
                start_date: sdate,
                end_date: edate,
                username:uName,
                reason:dreason,
            },
        }).then((res) => res).catch((err) => {
            errCheck(err);
        });
    }
}
